import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Globals } from "app/globals";

@Injectable()
export class ClientGuardService implements CanActivate {

    constructor(private _Globals: Globals, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        //console.log('next', route);

        if (this._Globals.getMode() === 'Administrator' || this._Globals.getMode() === 'Coach' || this._Globals.getMode() === 'Client') {
            //console.log('Logged in as client');
            this._Globals.hideChatBotForClients();
            return true;
        } else {
            console.log('Not client user');
            this.router.navigate(['/login']);
            this._Globals.deleteAllStorage();
            return false;
        }

    }


}
